import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const item = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
};

const AboutCell = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={item}
      className="bento-cell p-6 lgl:p-8 flex flex-col justify-center gap-3
                 lgl:col-start-6 lgl:col-end-11 lgl:row-start-1 lgl:row-end-3"
    >
      <span className="text-designColor text-sm font-medium uppercase tracking-wider">
        {t("banner.marketingLevier")}
      </span>
      <h2 className="text-xl lgl:text-2xl font-bold text-white font-titleFont">
        {t("bento.about.title")}
      </h2>
      <p className="text-sm lgl:text-base text-gray-400 leading-relaxed">
        {t("bento.about.description")}
      </p>
    </motion.div>
  );
};

export default AboutCell;
